<header class="page-header">
  <div class="header-content">
    <div class="header-text">
      <h1 class="page-title">{{ title() }}</h1>

      @if (showDescription() && description()) {
        <p class="page-description">{{ description() }}</p>
      }
    </div>

    <div class="header-actions">
      @if (showSecondaryButton()) {
        <umss-button
          *umssHasPermission="secondaryPermissions()"
          [size]="secondaryButtonSize()"
          [variant]="secondaryButtonVariant()"
          [label]="showTextSecondaryButton() ? secondaryButtonText() : ''"
          [leftIconName]="secondaryButtonIcon()"
          [disabled]="disabledSecondaryButton()"
          (click)="onSecondaryButtonClick()"
        />
      }
      @if (showButton()) {
        <umss-button
          *umssHasPermission="permissions()"
          [size]="buttonSize()"
          [variant]="buttonVariant()"
          [label]="showTextPrimaryButton() ? buttonText() : ''"
          [leftIconName]="buttonIcon()"
          [disabled]="disabledButton()"
          (click)="onButtonClick()"
        />
      }
    </div>
  </div>
</header>
